<template>
  <div>
    <div :class="`${node.type == 'group' ? 'node-hover' : ''}`">
      <div
          :style="{'margin-left': 25 * depth + 'px'}"
      >
        <div class="d-flex justify-content-between">
          <div  class="node" @click="expanded = !expanded">
            <span v-if="hasChildren">{{ expanded ? '&#9660' : '&#9658'}}</span>
            <span v-if="node.type == 'group'">{{ node.name }}</span>
          </div>
        </div>
        <div
            class="d-flex cursor-initial justify-content-between bg-black-light rounded-8 p-1 mb-1"
            v-if="node.type === 'endpoint'"
        >
          <div class="d-flex justify-content-between align-items-center mb-1">
            <p class="mb-0 fw-semibold">{{ node.name }}</p>
          </div>

          <div class="d-flex flex-wrap align-items-center gap-2">
            <div class="d-flex align-items-center gap-2 flex-wrap me-3">
              <span class="fw-bolder text-dark small me-1">Target:</span>
              <span class="text-dark small">Qty: {{ node.target_qty || '' }}</span>
              <span class="text-dark small">Value: {{ node.target_value || '' }}</span>
              <span class="text-dark small">Remarks:{{ node.target_remarks || '' }}</span>
            </div>

            <div class="d-flex align-items-center gap-2 flex-wrap me-3" v-if="!isSupervisorAuthorized">
              <span class="fw-bolder text-dark small me-1">Achievement:</span>
              <span class="text-dark small">Qty: {{ node.qty || '' }}</span>
              <span class="text-dark small">Value: {{ node.value || '' }}</span>
              <span class="text-dark small">Remarks:{{ node.remarks || '' }}</span>
            </div>

            <div class="d-flex align-items-center gap-2 flex-wrap" v-if="isSupervisorAuthorized">
              <span class="fw-bolder text-dark me-1 small">Achievement:</span>
              <input
                  v-model="node.qty"
                  type="text"
                  placeholder="Qty"
                  class="form-control form-control-sm"
                  style="width: 70px"
              >
              <input
                  v-model="node.value"
                  type="text"
                  placeholder="Value"
                  class="form-control form-control-sm"
                  style="width: 80px"
              >
              <input
                  v-model="node.remarks"
                  type="text"
                  placeholder="Remarks"
                  class="form-control form-control-sm"
                  style="width: 150px"
              >
            </div>
          </div>
        </div>

      </div>
    </div>
    <hr class="mb-1 mt-0" v-if="type == 'group'">
    <template v-if="expanded">
      <TargetAchievementTreeComponentForm
          v-for="item in node.active_child"
          :key="item.name"
          :parent="node"
          :depth="depth + 1"
          :node="item"
          :isSupervisorAuthorized="isSupervisorAuthorized"
      />
    </template>
  </div>
</template>

<script setup>
import {computed, ref} from "vue";

const props = defineProps({
  node: {
    type: Object,
    required: true
  },
  depth: {
    type: Number,
    default: 0
  },
  parent: {
    default: () => []
  },
  isSupervisorAuthorized:{
    default: false,
    type: Boolean
  }
})

const expanded = ref(true)

const hasChildren = computed(() => {
  return props.node.active_child.length
})

const type = computed(() => {
  return props.node.type
})

</script>

<style scoped>
.bg-black-light {
  background: #00000024;
}
.rounded-8 {
  border-radius: 8px;
}
.node {
  cursor: pointer;
}
.node-hover {
  padding: 10px 2px;
}
.node-hover:hover {
  background: #fffeec;
}
.cursor-initial {
  cursor: initial;
}
.cursor-pointer {
  cursor: pointer;
}
.w-30 {
  width: 30px;
}
.w-20 {
  width: 20px;
}
.z-999 {
  z-index: 999;
}
.w-44 {
  width: 44px;
}
</style>
